module.exports = {
      id: "chevron-down-usage",
      viewBox: "0 0 10 7",
      url: __webpack_public_path__ + "static/media/sprite-5b60ffc7028e429e00eae548481a2c11.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }